import React from "react";
import { FaIcon } from '../../common/Icons.jsx';
import Tooltip from '../../common/Tooltip.jsx';

import {
  survey_new_path,
  survey_edit_path
} from '~/routes';

const PublicLinkButton = ({
  reportApiId,
  assigneeApiId,
  surveyApiId,
  path = null,
  className = "",
  linkButtonLabel= I18n.t('submission_link')}
) => {
  path ||= reportApiId ?
    survey_new_path({report_api_id: reportApiId, assignee_api_id: assigneeApiId}) :
    survey_edit_path({survey_api_id: surveyApiId})

  const link = `${window.location.protocol}//${window.location.hostname}${path}`;

  return <div className={`link-copy-tool ${className}`}>
    { linkButtonLabel && <label> {linkButtonLabel} </label> }
      <div className="input-group">
        <input type="text" className="form-control" value={link} onFocus={(e) => e.target.select()} onChange={() => {}}/>
        <div className="input-group-addon copy-button btn-primary" onClick={(e) => navigator.clipboard.writeText(link)}>
        <Tooltip trigger='click' title={I18n.t('copied_to_clipboard')}>
          <FaIcon type='copy'/>
        </Tooltip>
        </div>
    </div>
  </div>
};

export default PublicLinkButton;
